import { NOTICE_CHANNELS, NOTICE_FINE_PRINT, SCENES } from "./content";
import { usePageMeta } from "./hooks";
import { CloseRankingMock } from "./mockups/CloseRankingMock";
import { CourtCalendarMock } from "./mockups/CourtCalendarMock";
import { FinancePanel } from "./mockups/FinancePanel";
import { FormatsShowcase } from "./mockups/FormatsShowcase";
import { LockScreenMock } from "./mockups/LockScreenMock";
import { PlayerHomeMock } from "./mockups/PlayerHomeMock";
import { RegistrationPhone } from "./mockups/RegistrationPhone";
import { ResultCaptureMock } from "./mockups/ResultCaptureMock";
import { BrandSection } from "./organizer/BrandSection";
import { DemoSection } from "./organizer/DemoSection";
import { Faq } from "./organizer/Faq";
import { HowItWorks } from "./organizer/HowItWorks";
import { LiveProof } from "./organizer/LiveProof";
import { MoreFeatures } from "./organizer/MoreFeatures";
import { OrgHero } from "./organizer/OrgHero";
import { PainGrid } from "./organizer/PainGrid";
import { Pricing } from "./organizer/Pricing";
import { Chapter, TourIntro, TourScene } from "./organizer/TourScene";
import "./OrganizerPage.css";

/** /organizador: la página de venta para organizadores (Eduardo 2026-09-29).
 * Orden: encabezado con precio y demo → prueba en vivo → dolores → 4 pasos →
 * recorrido antes/durante/después → tu marca → y además → precio → preguntas
 * → formulario de demo. */
export function OrganizerPage() {
  usePageMeta("organizer");
  return (
    <main className="t123-org">
      <OrgHero />
      <LiveProof />
      <PainGrid />
      <HowItWorks />
      <TourIntro />

      <Chapter id="antes" number={1} label="Antes del torneo" title="Inscripciones y cobro" tone="white">
        <TourScene copy={SCENES.registration} mock={<RegistrationPhone />} />
        <TourScene copy={SCENES.payments} mock={<FinancePanel />} reverse />
      </Chapter>

      <Chapter id="durante" number={2} label="Durante el torneo" title="Cuadros, canchas, resultados y avisos" tone="soft">
        <TourScene copy={SCENES.formats} mock={<FormatsShowcase />} wide bulletsColumns={2} />
        <TourScene copy={SCENES.courts} mock={<CourtCalendarMock />} reverse />
        <TourScene copy={SCENES.results} mock={<ResultCaptureMock />} />
        <TourScene
          copy={SCENES.players}
          reverse
          mock={
            <div className="t123-org__duo">
              <LockScreenMock />
              <PlayerHomeMock />
            </div>
          }
          extra={
            <div className="t123-org__channels">
              <div className="t123-chip-row">
                {NOTICE_CHANNELS.map((channel) => (
                  <span key={channel.label} className={channel.live ? "t123-chip" : "t123-chip t123-chip--muted"}>
                    {channel.label} {channel.live ? "✓" : "· Próximamente"}
                  </span>
                ))}
              </div>
              <p className="t123-org__fine">{NOTICE_FINE_PRINT}</p>
            </div>
          }
        />
      </Chapter>

      <Chapter id="despues" number={3} label="Después del torneo" title="Campeones y ranking" tone="green">
        <TourScene copy={SCENES.closing} mock={<CloseRankingMock />} />
      </Chapter>

      <BrandSection />
      <MoreFeatures />
      <Pricing />
      <Faq />
      <DemoSection />
    </main>
  );
}
